export const actionMatcher = actionToMatch => action => action.type === actionToMatch
